import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DISCOUNT_CODE_AUTHORIZER_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import {
  clearDiscountCodeAuthorizer,
  getDiscountCodeAuthorizer,
} from '../../../../actions/sales/DiscountCodeAuthorizer';
import DiscountCodeAuthorizerBasicInformationResource from './resource/DiscountCodeAuthorizerBasicInformationResource';
import DiscountCodeAuthorizerToolbar from './DiscountCodeAuthorizerToolbar';

export const DiscountCodeAuthorizer = ({
  breadcrumbs,
  dispatchGetDiscountCodeAuthorizer,
  dispatchClearDiscountCodeAuthorizer,
  match: {
    params: { id: discountCodeAuthorizerId },
  },
  loading,
  discountCodeAuthorizer,
}) => {
  useLayoutEffect(() => {
    dispatchGetDiscountCodeAuthorizer({ discountCodeAuthorizerId });

    return () => dispatchClearDiscountCodeAuthorizer();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (discountCodeAuthorizer.isEmpty())
    content = <NoDataResource returnPage={DISCOUNT_CODE_AUTHORIZER_PATH} />;
  else {
    const discountCodeAuthorizerJson = discountCodeAuthorizer.toJS();
    content = (
      <>
        <div className="row mb-4">
          <div className="col-md-8">
            <h3>Información Básica</h3>
            <DiscountCodeAuthorizerBasicInformationResource
              discountCodeAuthorizer={discountCodeAuthorizerJson}
            />
          </div>
        </div>
      </>
    );

    toolbar = (
      <DiscountCodeAuthorizerToolbar
        discountCodeAuthorizerId={discountCodeAuthorizerJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Autorizador de Código de Descuento"
      content={content}
    />
  );
};

DiscountCodeAuthorizer.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearDiscountCodeAuthorizer: PropTypes.func.isRequired,
  dispatchGetDiscountCodeAuthorizer: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  discountCodeAuthorizer: PropTypes.instanceOf(Immutable.Map).isRequired,
};

DiscountCodeAuthorizer.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearDiscountCodeAuthorizer: clearDiscountCodeAuthorizer,
  dispatchGetDiscountCodeAuthorizer: getDiscountCodeAuthorizer,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Autorizadores de Códigos de Descuento',
      href: DISCOUNT_CODE_AUTHORIZER_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  discountCodeAuthorizer: SalesUnit.DiscountCodeAuthorizer.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.DiscountCodeAuthorizer.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountCodeAuthorizer);
